import { createReducer, on } from '@ngrx/store';
import * as spinnerAction from './spinner.action'
export const initialState = {
  isShow: false,
};

export const spinnerReducer = createReducer(
  initialState,
  on(spinnerAction.showSpinner, (state, _) => ({ ...state, isShow: true })),
  on(spinnerAction.hideSpinner, (state, _) => ({ ...state, isShow: false })),
);
